module.exports = __webpack_public_path__ + "img/video-18.077539f7.png";